import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=08a8f7f2&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Payment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a8f7f2')) {
      api.createRecord('08a8f7f2', component.options)
    } else {
      api.reload('08a8f7f2', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=08a8f7f2&", function () {
      api.rerender('08a8f7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/Summary/Payment.vue"
export default component.exports